import { httpClient } from '@/services/http/httpClient'

export type UpdatePortfolioColumnParams = {
  portfolioColumnId: string
  portfolioId: string
  title: string
}

export async function updatePortfolioColumn({
  portfolioColumnId,
  title,
  portfolioId,
}: UpdatePortfolioColumnParams) {
  await httpClient.put(`/projects/portfolio-columns/${portfolioId}`, {
    title,
    portfolioId,
    portfolioColumnId,
  })
}
